<app-standard-data-table
    (gridRequested)="gridRequested($event)"
    [source]="edgeDevices"
    [sorts]="[{ prop: 'name', dir: 'asc' }]"
    [columns]="columns$ | async"
    [selectionType]="SelectionType.single"
    (rowSelected)="emitSelect($event)"
    [noRecordsMessage]="noDeviceRecords"
></app-standard-data-table>

<ng-template #deviceStatusTemplate let-row="row">
    <app-device-status class="device-and-asset-status-position" [status]="row?.deviceStatus"></app-device-status>
</ng-template>

<ng-template #remoteSupportTemplate let-row="row">
    @if (row?.remoteSupportEnabledAt != null) {
        <a [ngbTooltip]="'globalAdministration.remoteMaintenance.activatedRemoteMaintenance' | translation | async" placement="left" (click)="emitEdit(row)">
            <span class="fa fa-desktop text-success"></span>
        </a>
    }
</ng-template>

<ng-template #commandsTemplate let-row="row">
    <a *appHasPermission="'edgeDevice.write'" [ngbTooltip]="'actions.edit' | translation | async" placement="left" (click)="emitEdit(row)">
        <span class="edit-icon default-icon-color"></span>
    </a>
</ng-template>

<ng-template #noDeviceRecords>
    <div class="mx-auto mt-4 text-center default-icon-color">
        <i class="fas fa-info-circle fa-7x"></i>
        <div class="no-records-message">{{ 'devices.hints.notFound' | translation | async }}</div>

        <ng-container>
            <div class="no-records-message-detail">{{ 'devices.hints.notFoundDetail' | translation | async }}</div>

            <button type="button" class="btn btn-primary mt-3" (click)="provisionEdgeDevice()">{{ 'administration.provisioning.name' | translation | async }}</button>
        </ng-container>
    </div>
</ng-template>
